module.exports = __webpack_public_path__ + "static/img/GettyImages-607283026.4f8eab1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/GettyImages-607283026.jpg
// module id = YvSZ
// module chunks = 0